import type { InferResponseType } from 'hono/client'
import type { AppType } from '@/api/index'
import { hc } from 'hono/client'

let API_BASE_URL = 'https://odds-dev.nxtbets.com'

export function setApiBase(url: string) {
  API_BASE_URL = url
  _client = hc<AppType>(API_BASE_URL)
}

let _client = hc<AppType>(API_BASE_URL)

// Create the Hono client with your API type
export const client = new Proxy({} as ReturnType<typeof hc<AppType>>, {
  get(_target, prop) {
    return (_client as any)[prop]
  },
})

// Extract the API response type - need to await the promise to get the actual response
type EventsResponse = InferResponseType<typeof client.api.v1.events.$get, 200>

export type EventResponseData = EventsResponse['data']
export type EventMarkets = EventResponseData[number]

export type FanDuelSelectionData = NonNullable<
  EventMarkets['selections'][number]['odds']['FanDuel']
>['selectionData']

export type DraftKingsSelectionData = NonNullable<
  EventMarkets['selections'][number]['odds']['DraftKings']
>['selectionData']

export type Bet365SelectionData = NonNullable<
  EventMarkets['selections'][number]['odds']['Bet365']
>['selectionData']

export type BetMGMSelectionData = NonNullable<
  EventMarkets['selections'][number]['odds']['BetMGM']
>['selectionData']
